import { request } from "../base";
import type { Project } from "../pro";

export const adminProjectsApi = {
	async listProjects(params?: Record<string, string>) {
		const query = params ? `?${new URLSearchParams(params).toString()}` : "";
		return request<Project[]>(`/api/admin/projects${query}`);
	},

	async getProject(id: string) {
		return request<Project & { photos: unknown[] }>(
			`/api/admin/projects/${id}`,
		);
	},

	async createProject(data: {
		proId: string;
		title: string;
		description?: string;
	}) {
		return request<Project>(`/api/admin/projects`, {
			method: "POST",
			body: data,
		});
	},

	async updateProject(id: string, data: Partial<Project>) {
		return request<Project>(`/api/admin/projects/${id}`, {
			method: "PUT",
			body: data,
		});
	},

	async deleteProject(id: string) {
		return request(`/api/admin/projects/${id}`, {
			method: "DELETE",
		});
	},

	async publishProject(id: string) {
		return request<Project>(`/api/admin/projects/${id}/publish`, {
			method: "POST",
		});
	},

	async archiveProject(id: string) {
		return request<Project>(`/api/admin/projects/${id}/archive`, {
			method: "POST",
		});
	},

	async setProjectFeatured(id: string, isFeatured: boolean) {
		return request<Project>(`/api/admin/projects/${id}/featured`, {
			method: "PUT",
			body: { isFeatured },
		});
	},

};
